import LinkWithTransitionLock from "./LinkWithTransitionLock.jsx"

export default LinkWithTransitionLock
